import { useDispatch, useSelector } from '@/store';
import CheckboxList from './CheckboxList';
import CheckboxListItem from './CheckboxListItem';
import { useAnalyticsEventTracker } from '@/gaEvents';
import { TelemetryKey, toggleTelemetry } from '../../../slices/devicesAnalysisSlice';
import { type FC } from 'react';
import { MetricField } from '@/__generated__/graphql';
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/macro';
import { UnitsAutocomplete } from '@components/UnitsAutocomplete';
import { VolumeUnit } from '@/utils/units';

const SidebarVolumeCheckboxList: FC = () => {
  const { _ } = useLingui();
  const dispatch = useDispatch();
  const { checkBoxEvent, selectorEvent } = useAnalyticsEventTracker('Station Analysis');
  const { telemetry } = useSelector((state) => state.devices_analysis_store);

  return (
    <CheckboxList>
      {telemetry.availableFields.includes(MetricField.StoredVolume) && (
        <CheckboxListItem
          checked={telemetry[TelemetryKey.StoredVolume]}
          onClick={() => {
            checkBoxEvent({
              label: 'stored-vol',
              value: !telemetry[TelemetryKey.StoredVolume],
            });
            dispatch(toggleTelemetry(TelemetryKey.StoredVolume));
          }}
          label={_(msg`Volumen almacenado`)}
          secondaryAction={
            <UnitsAutocomplete
              size="small"
              metric={MetricField.StoredVolume}
              label=""
              value={telemetry[TelemetryKey.StoredVolumeUnit]}
              onChange={(_, value) => {
                const unit = value as VolumeUnit;
                selectorEvent({ label: 'stored-vol-unit', value: unit });
                dispatch(toggleTelemetry({ [TelemetryKey.StoredVolumeUnit]: unit }));
              }}
              disableClearable
            />
          }
        />
      )}
      {telemetry.availableFields.includes(MetricField.AccumulatedVolume) && (
        <CheckboxListItem
          checked={telemetry[TelemetryKey.AccumulatedVol]}
          onClick={() => {
            checkBoxEvent({
              label: 'accumulated-vol',
              value: !telemetry[TelemetryKey.AccumulatedVol],
            });
            dispatch(toggleTelemetry(TelemetryKey.AccumulatedVol));
          }}
          label={_(msg`Volumen acumulado`)}
          secondaryAction={
            <UnitsAutocomplete
              size="small"
              metric={MetricField.AccumulatedVol}
              label=""
              value={telemetry[TelemetryKey.AccumulatedVolUnit]}
              onChange={(_, value) => {
                const unit = value as VolumeUnit;
                selectorEvent({ label: 'accumulated-vol-unit', value: unit });
                dispatch(toggleTelemetry({ [TelemetryKey.AccumulatedVolUnit]: unit }));
              }}
              disableClearable
            />
          }
        />
      )}
      {telemetry.availableFields.includes(MetricField.VolumeHour) && (
        <CheckboxListItem
          checked={telemetry[TelemetryKey.VolumeHour]}
          onClick={() => {
            checkBoxEvent({ label: 'vol-hour', value: !telemetry[TelemetryKey.VolumeHour] });
            dispatch(toggleTelemetry(TelemetryKey.VolumeHour));
          }}
          label={_(msg`Volumen hora`)}
          secondaryAction={
            <UnitsAutocomplete
              size="small"
              metric={MetricField.VolumeHour}
              label=""
              value={telemetry[TelemetryKey.VolumeHourUnit]}
              onChange={(_, value) => {
                const unit = value as VolumeUnit;
                selectorEvent({ label: 'vol-hour-unit', value: unit });
                dispatch(toggleTelemetry({ [TelemetryKey.VolumeHourUnit]: unit }));
              }}
              disableClearable
            />
          }
        />
      )}
      {telemetry.availableFields.includes(MetricField.VolumeDay) && (
        <CheckboxListItem
          checked={telemetry[TelemetryKey.VolumeDay]}
          onClick={() => {
            checkBoxEvent({ label: 'vol-day', value: !telemetry[TelemetryKey.VolumeDay] });
            dispatch(toggleTelemetry(TelemetryKey.VolumeDay));
          }}
          label={_(msg`Volumen día`)}
          secondaryAction={
            <UnitsAutocomplete
              size="small"
              metric={MetricField.VolumeDay}
              label=""
              value={telemetry[TelemetryKey.VolumeDayUnit]}
              onChange={(_, value) => {
                const unit = value as VolumeUnit;
                selectorEvent({ label: 'vol-day-unit', value: unit });
                dispatch(toggleTelemetry({ [TelemetryKey.VolumeDayUnit]: unit }));
              }}
              disableClearable
            />
          }
        />
      )}
      {telemetry.availableFields.includes(MetricField.VolumeMonth) && (
        <CheckboxListItem
          checked={telemetry[TelemetryKey.VolumeMonth]}
          onClick={() => {
            checkBoxEvent({ label: 'vol-month', value: !telemetry[TelemetryKey.VolumeMonth] });
            dispatch(toggleTelemetry(TelemetryKey.VolumeMonth));
          }}
          label={_(msg`Volumen mes`)}
          secondaryAction={
            <UnitsAutocomplete
              size="small"
              metric={MetricField.VolumeMonth}
              label=""
              value={telemetry[TelemetryKey.VolumeMonthUnit]}
              onChange={(_, value) => {
                const unit = value as VolumeUnit;
                selectorEvent({ label: 'vol-month-unit', value: unit });
                dispatch(toggleTelemetry({ [TelemetryKey.VolumeMonthUnit]: unit }));
              }}
              disableClearable
            />
          }
        />
      )}
    </CheckboxList>
  );
};

export default SidebarVolumeCheckboxList;
